import React from 'react';
import { FileTextIcon } from 'lucide-react';
import type { PackageDocument, PackageEmail, PackageVersion, ReceivedDocument } from '../../types/docmagic';
import { formatDateTime } from '../../utils/datetime';
import { DataTable } from './DataTable';
const docTone: Record<PackageDocument['status'], string> = {
  Signed: 'text-success',
  'Awaiting Signature': 'text-[#0b5cab]',
  Informational: 'text-muted'
};
const emailTone: Record<PackageEmail['status'], string> = {
  Opened: 'text-success',
  Delivered: 'text-ink',
  Bounced: 'text-error'
};
export function DocumentsTab({
  rows
}: {
  rows: PackageDocument[];
}) {
  return <DataTable rows={rows} rowKey={r => r.id} emptyTitle="No documents" emptyText="DocMagic hasn't returned any documents for this package." columns={[{
    header: 'Document',
    render: r => <span className="inline-flex items-center gap-2" data-id="element-151" data-mp="naorvd6k9i2r">
              <FileTextIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-152" data-mp="n941lzra4lap" />
              {r.name}
            </span>
  }, {
    header: 'Pages',
    render: r => r.pages
  }, {
    header: 'Status',
    render: r => <span className={`font-medium ${docTone[r.status]}`} data-id="element-153" data-mp="6h7lpse7rgkq">{r.status}</span>
  }]} data-id="element-150" data-mp="1azq7bkdt9thj" />;
}
export function DocumentsReceivedTab({
  rows
}: {
  rows: ReceivedDocument[];
}) {
  return <DataTable rows={rows} rowKey={r => r.id} emptyTitle="Nothing received yet" emptyText="Signed packages and completion certificates appear here once retrieved from DocMagic." columns={[{
    header: 'File',
    render: r => <a href="#" onClick={e => e.preventDefault()} className="text-brand hover:underline" data-id="element-155" data-mp="3fmxfeewhwtxs">
              {r.name}
            </a>
  }, {
    header: 'Source',
    render: r => r.from
  }, {
    header: 'Received',
    render: r => formatDateTime(r.receivedAt)
  }, {
    header: 'Size',
    align: 'right',
    render: r => `${(r.sizeKb / 1024).toFixed(1)} MB`
  }]} data-id="element-154" data-mp="3tmygnvgoa3ds" />;
}
export function EmailsTab({
  rows
}: {
  rows: PackageEmail[];
}) {
  return <DataTable rows={rows} rowKey={r => r.id} emptyTitle="No emails sent" emptyText="Participant notifications and reminders will be listed here." columns={[{
    header: 'Subject',
    render: r => r.subject
  }, {
    header: 'To',
    render: r => <span className="text-muted" data-id="element-157" data-mp="3q5ap81zk595s">{r.to}</span>
  }, {
    header: 'Sent',
    render: r => formatDateTime(r.sentAt)
  }, {
    header: 'Status',
    render: r => <span className={`font-medium ${emailTone[r.status]}`} data-id="element-158" data-mp="3h4mb77a5z8sw">{r.status}</span>
  }]} data-id="element-156" data-mp="3c6kwsznonxnr" />;
}
export function VersionsTab({
  rows
}: {
  rows: PackageVersion[];
}) {
  return <DataTable rows={[...rows].reverse()} rowKey={r => r.id} emptyTitle="No versions" emptyText="Package versions will appear after the first sync." columns={[{
    header: 'Version',
    render: r => <span className="font-semibold" data-id="element-160" data-mp="225fe7erzxzj6">v{r.version}</span>
  }, {
    header: 'Change',
    render: r => r.note
  }, {
    header: 'By',
    render: r => r.createdBy
  }, {
    header: 'Date',
    render: r => formatDateTime(r.createdAt)
  }]} data-id="element-159" data-mp="25oxswt7uuxyf" />;
}